// extracted by mini-css-extract-plugin
module.exports = {"priceSkeleton":"az_nxc","strikethroughPriceWrapper":"az_oxc","marginLeft":"az_pxc","alignStart":"az_qxc","noPrice":"az_rxc"};